import PropTypes from 'prop-types';

export const propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  control: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  setError: PropTypes.func,
  clearErrors: PropTypes.func,
};

export const defaultProps = {
  control: null,
  setError: undefined,
  clearErrors: undefined,
  title: { value: '', key: '' }, // Default to empty string if not provided
  subText: { value: '', key: '' }, // Default to empty string if not provided
  optionalText: { value: '', key: '' }, // Default to empty string if not provided
  icon: undefined, // Default to no icon
};

export const birthdayFieldsContextPropTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.shape({
    value: PropTypes.string,
    key: PropTypes.string,
  }),
  subText: PropTypes.shape({
    value: PropTypes.string,
    key: PropTypes.string,
  }).isRequired,
  optionalText: PropTypes.shape({
    value: PropTypes.string,
    key: PropTypes.string,
  }),
  icon: PropTypes.string, // Accepts the icon name as a string
};
